import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import {
  ContropartiPrecedentiAddComponent
} from 'src/app/common/form/controparti-precedenti-add/controparti-precedenti-add.component';
import { Controparte } from 'src/app/common/models/controparte';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { ServicePathsSettings } from '../../../../core/configuration/service-paths-settings';
import { RicercaAnagraficheFormComponent } from '../../../form/ricerca-anagrafiche-form.component';
import { Parte } from '../../../models/parte';
import { SezioneControparti } from '../../../models/sezioni/sezione-controparti';
import { ParteAnagraficaAddComponent } from '../parte-anagrafica-update/parte-anagrafica-add.component';
import { ContropartiAssociativaAddComponent } from './controparti-associativa-add.component';

declare var closeModal: any;
declare var openModal: any;
declare var $: any;

@Component({
  selector: 'div [controparti-mod-add]',
  templateUrl: 'controparti-mod-aggiungi.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ContropartiModAggiungi {
  haveNewAnagrafica: boolean = false;
  viewSearchMask: boolean = true;
  addControparteUrl: string;
  idSezione: string;
  idFascicolo: string;
  tipoFascicolo:string;
  idParent: string;
  idPratica: string;

  flagAttore: boolean;

  tabsWidth = [33.33,33.33,33.33];

  contropartiPrecedenti: Controparte[] = [];
  @Input() isPatologia: boolean;
  @Input() titleSection: string = 'controparte';
  isPrd: boolean = PropertiesSettings.ID_TENANTS_PRD();
  @Output() onReturn: EventEmitter<SezioneControparti> = new EventEmitter<SezioneControparti>();
  @ViewChild('formAddAnagrafica') modaleAnagrafica: ParteAnagraficaAddComponent;
  @ViewChild('formAddAssociativaAnagrafica') modaleAssociativaAnagrafica: ContropartiAssociativaAddComponent;
  @ViewChild('formRicercaParte') modaleRicerca: RicercaAnagraficheFormComponent<Parte>;
  @ViewChild('formAddAssociativaRicerca') modaleAssociativaRicerca: ContropartiAssociativaAddComponent;
  @ViewChild('copiaDaPrecedenti') modaleCopiaDaPrecedenti: ContropartiPrecedentiAddComponent;

  inizializza(urlAggiungiInAnagrafica: string, addControparteUrl, idPratica, idSezione, idFascicolo, idParent, tipoPratica, idTipoFascicolo,tipoFascicolo, isAttore?, ) {
    this.flagAttore = isAttore;
    this.addControparteUrl = addControparteUrl;
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.idParent = idParent;
    this.idPratica = idPratica;
    this.tipoFascicolo = tipoFascicolo;
    if (this.modaleAnagrafica) this.modaleAnagrafica.inizializza(urlAggiungiInAnagrafica,tipoPratica, idTipoFascicolo, true);

    // if(this.modaleAnagrafica) this.modaleAnagrafica.inizializza(urlAggiungiInAnagrafica, tipoPratica);
    if(this.modaleRicerca) this.modaleRicerca.inizializza(ServicePathsSettings.URL_SEARCH_PARTE, true);
    if(this.modaleCopiaDaPrecedenti) this.modaleCopiaDaPrecedenti.inizializza(this.idPratica, this.addControparteUrl, this.idSezione, this.idFascicolo, this.idParent, this.tipoFascicolo);
    $('a[href="#tabcontent7"]').tab('show');
    openModal('modalmodaggiungi');
  }

  createForm() {
    this.haveNewAnagrafica = false;
    this.viewSearchMask = true;
    $('a[href="#tabcontent7"]').tab('show');
    if (this.modaleRicerca) {
      this.modaleRicerca.setTextEmpty();
      this.modaleRicerca.resetResults();
    }

    this.modaleAnagrafica.createForm();

    // this.modaleAnagrafica.createForm();
  }

  newAnagrafica(parte: Parte) {
    this.haveNewAnagrafica = true;
    this.modaleAssociativaAnagrafica.inizializza(parte, this.addControparteUrl, this.idSezione, this.idFascicolo);
  }

  manageModal(sezione: SezioneControparti) {
      this.createForm();
      closeModal('modalmodaggiungi');
      this.onReturn.emit(sezione);
  }

  manageModalControparte(controparte) {
      this.createForm();
      closeModal('modalmodaggiungi');
      this.onReturn.emit(controparte);
  }

  foundedAnagrafica(parte: Parte) {
    this.viewSearchMask = false;
    this.modaleAssociativaRicerca.inizializza(parte, this.addControparteUrl, this.idSezione, this.idFascicolo);
  }

  inserisciDaPrecedenti(event){

  }

  manageModalPrecedenti(sezione: SezioneControparti){
    closeModal('modalmodaggiungi');
    this.onReturn.emit(sezione);
  }

  assegnaPrecedenti(event){
    this.contropartiPrecedenti = event;
    // this.tabsWidth = (event && event.length > 0 ) ? [50,50,50] : [33.33,33.33,33.33];
  }
}
